import { ReactNode } from "react";

import BreadCrumb from "shared/BreadCrumb";
import { AppLayout } from "shared/Layout";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations, useI18n } from "utils/with-i18n.utils";
import { fetchSEO, withSeo } from "utils/with-seo.utils";

import { Banner } from "../Banner";
import { TextBlock } from "../TextBlock";

import { Contact } from "./Contact";

export type ModesDePaiementProps = Awaited<
  ReturnType<typeof getStaticProps>
>["props"];

export const ModesDePaiement = () => {
  const i18n = useI18n();

  return (
    <>
      <div className="mx-auto max-w-[1440px]">
        <BreadCrumb
          parts={[
            { label: i18n.t("breadcrumb.home"), to: "/" },
            {
              label: i18n.t("breadcrumb.paymentMethods"),
              to: "/modes-de-paiement",
            },
          ]}
        />

        <div className="px-5 xl:px-32">
          <Banner firstLine={i18n.t("paymentMethods.title")} />

          <div className="flex flex-col gap-8 mb-16 lg:gap-16">
            <TextBlock
              title={i18n.t("paymentMethods.firstTitle", {}, { html: true })}
              description={i18n.t(
                "paymentMethods.firstParagraph",
                {},
                { html: true },
              )}
            />
            <TextBlock
              title={i18n.t("paymentMethods.secondTitle", {}, { html: true })}
              description={i18n.t(
                "paymentMethods.secondParagraph",
                {},
                { html: true },
              )}
            />
            <TextBlock
              title={i18n.t("paymentMethods.thirdTitle", {}, { html: true })}
              description={i18n.t(
                "paymentMethods.thirdParagraph",
                {},
                { html: true },
              )}
            />
            <TextBlock
              title={i18n.t("paymentMethods.fourthTitle", {}, { html: true })}
              description={i18n.t(
                "paymentMethods.fourthParagraph",
                {},
                { html: true },
              )}
            />
            <TextBlock
              title={i18n.t("paymentMethods.fifthTitle", {}, { html: true })}
              description={i18n.t(
                "paymentMethods.fifthParagraph",
                {},
                { html: true },
              )}
            />
          </div>

          <Contact />
        </div>
      </div>
    </>
  );
};

ModesDePaiement.getLayout = (
  page: ReactNode,
  pageProps: ModesDePaiementProps,
) => (
  <AppLayout withBanner {...pageProps}>
    {page}
  </AppLayout>
);

export const getStaticProps = async () => {
  const translations = await fetchTranslations([
    "marquee",
    "payment-methods",
    "breadcrumb",
  ]);

  const seo = await fetchSEO("modes-de-paiement");

  return {
    props: {
      translations,
      seo,
      settings: await fetchSettings(),
    },
  };
};

export default withApp(ModesDePaiement, [withSeo]);
